<template>
  <li class="document-list-item-wrapper">
    <slot />
  </li>
</template>

<style lang="less" scoped>
.document-list-item-wrapper {
  min-height: 64px;
  max-height: 64px;
  height: 100%;
  background-color: rgb(var(--v-theme-bgDefault));

  &:hover {
    background-color: rgb(var(--v-theme-bgDark));
    cursor: pointer;
  }
}
</style>
